import { useState } from "react";
import { Box, Typography } from "@mui/material"
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AuthCode from 'react-auth-code-input';

import BaseLink from "../../BaseLink"
import BaseColorText from "../../BaseColorText";
import BaseButton from "../../BaseButton";
import HelpText from "../../HelpText";

import { useLazyQuery } from "@apollo/client";
import { VerifyPhysicianCode } from "../../../apollo-client/api-query";
import { showErrorToast } from "../../../utils/toast";

/**
 * @param {Object} props
 */
const PinCodeForm = ({ setKitCode, onNextStep }) => {
  const [verifyCode, { loading }] = useLazyQuery(VerifyPhysicianCode, {fetchPolicy: 'network-only'})

  const [authCode, setAuthCode] = useState('');

  const handleClickSubmit = async () => {
    if (authCode.length === 6) {
      verifyCode({
        variables: {
          physicianCode: authCode
        }
      }).catch(error => {
        showErrorToast({
          message: error.message
        })
      }).then(({ data }) => {
        if (data?.verifyPhysicianCode) {
          onNextStep()
        } else {
          showErrorToast({
            message: 'The registration code is not correct'
          })
        }
      })
    } else {
      showErrorToast({
        message: 'Input 6 registration code'
      })
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%'
      }}
    >
      <Box sx={{
        width: '100%',
        mt: '70px'
      }}>
        <Typography variant="h1">
          Welcome to
        </Typography>
        <Typography
          variant="h1"
            sx={{
            mt: '12px'
          }}
        >
          <BaseColorText isGradient gradientColor='#5A3BC7 30%, #5FB2EC 90%'>Physician’s portal!</BaseColorText>
        </Typography>
        <Typography
          variant="h4"
          color='primary.darkGray'
          sx={{
            mt: '20px'
          }}
        >
          Please enter the registration code from your sales associate.
        </Typography>
        <Box sx={{
          mt: '30px',
        }}>
          {/* <form onSubmit={handleSubmit}> */}
            <Typography sx={{
              fontWeight: 500,
              fontSize: '12px',
              color: '#46545F',
            }}>
              Registration Code <BaseColorText color="#E73E3E">*</BaseColorText>
            </Typography>
            <AuthCode
              onChange={(res) => {
                setAuthCode(res.toUpperCase())
                setKitCode(res.toUpperCase())
              }}
              inputClassName="authCodeVerificationInput"
              containerClassName="authCodeVerificationContainer"
            />
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <BaseButton
                loading={loading}
                disabled={loading || authCode.length !== 6}
                variant='contained'
                buttonType='primary'
                type='button'
                sx={{
                  mt: { xs: '30px', sm: '50px' },
                }}
                onClick={handleClickSubmit}
              >
                Register <ArrowForwardIosIcon sx={{ ml: '20px', fontSize: '16px' }} />
              </BaseButton>
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: 500,
                  mt: '30px'
                }}
              >
                Ask your sales associate for a registration number
              </Typography>
            </Box>
          {/* </form> */}
        </Box>
      </Box>
      <Box
        sx={{
          mt: '80px'
        }}
      >
        <Box sx={{
          display: 'flex',
          justifyContent: 'center'
        }}>
          <Typography
            variant="body"
            color='primary.darkGray'
          >
            Already have an account? {' '}
            <BaseLink to='/login' underline={true}>
              Click here to login
            </BaseLink>
          </Typography>
        </Box>
        <HelpText sx={{
          borderTop: '1px solid #ABB7C0',
          py: '30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mt: '4px'
        }}>
        </HelpText>
      </Box>
    </Box>
  )
}

export default PinCodeForm;